import { render, staticRenderFns } from "./Test2.vue?vue&type=template&id=77b21888&scoped=true&"
import script from "./Test2.vue?vue&type=script&lang=js&"
export * from "./Test2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b21888",
  null
  
)

export default component.exports